import { IonContent, IonIcon,IonToast, IonPage, IonHeader, useIonModal, useIonAlert, IonToolbar, IonCard, IonCardContent, IonTitle, IonButtons, IonButton, IonItem, IonList, IonThumbnail, IonLabel } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import './ReceivePage.css';
import { arrowBackOutline, closeOutline } from "ionicons/icons";
import { useAppDispatch, useAppSelector } from '../../services/redux/hook';
import { Asset, BuyWidgetParams, WalletInfoState } from "../../types/types";
import BaseModalComponent from "../../components/BaseModalComponent/BaseModalComponent";
import ReceiveStellarPayPage from "./ReceiveStellarPay";
import * as Sentry from '@sentry/react';

import { useHistory } from 'react-router-dom';
import { ebioroApi, useGetUserInfoQuery } from "../../services/api/ebioro/ebioro";
import { Browser } from "@capacitor/browser";
import VirtualAccountCreateKYC from "./virtual-account/create/VirtualAccountCreateKYC";
import QrCodePageStellarToken from "../qr_code/QrCodePageStellarToken";

import { Provider } from "react-redux";
import { store } from "../../services/redux/store";
import { closeModal } from "@/services/redux/slices";

import { RiBankLine, RiBankCardLine, RiQrCodeLine, RiLink } from "react-icons/ri";
import { IconContext } from 'react-icons';

const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';

const Page: React.FC = () => {
    const history = useHistory();
    const pageRef = useRef(null);
    const dispatch = useAppDispatch();
    const [isSpinner, setIsSpinner] = useState(false);
    const asset: Asset = useAppSelector((state) => state.selectedAsset);
    const [goBack, setGoBack] = useState(false);
    const nav = document.querySelector("ion-nav");

    const [presentingElement, setPresentingElement] = useState<HTMLElement | null>(null);
    const [presentKyc, dismissKyc] = useIonModal(BaseModalComponent, { component: VirtualAccountCreateKYC });
    const [presentAlert] = useIonAlert();
    const authToken = useAppSelector((state) => state.sep10AuthToken.tokens[ebioroAuthDomain]);
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);

    const { data: userInfo } = useGetUserInfoQuery(undefined, { skip: authToken === undefined });
    const { t, i18n } = useTranslation();
    // const { data: virtualAccounts } = useGetVirtualAccountsQuery({ userId: userInfo?.id as string }, { skip: authToken === undefined || !userInfo?.id });

    const presentErrorAlert = (error: any) => {
        const message = typeof error === 'string' ? error : (error?.message ?? 'Unexpected error');
        presentAlert({
            header: 'Error',
            message,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],
        })
    }

    const [showToast, setShowToast] = useState(false);

    const close = () => {

        dispatch(closeModal());

    }

    useEffect(() => {

        const init = async () => {
            const canGoBackResult = await nav?.canGoBack();
            if (canGoBackResult) {
                setGoBack(true);
            }
        }
        init();
    }, []);



    const handleNavigation = () => {
        if (goBack) {
            nav?.pop();
        } else {
            close();
        }
    }


    // const presentVirtualAccountModal = async () => {

    //     if (virtualAccounts && virtualAccounts.length > 0) {
    //         // User already has virtual accounts, no need to present KYC
    //         return;
    //     }

    //     dispatch(openModal({ dismissFunc: dismissKyc }));

    //     setTimeout(() => {

    //         presentKyc({})

    //     }, 100)

    // }



    const presentRecieveStellarPayModal = async () => {
        nav?.push(() => <ReceiveStellarPayPage />)
    }

    useEffect(() => {
        setPresentingElement(pageRef.current);
        if (!walletInfo?.account_key) {
            history.replace("/"); // Redirects without keeping history
        }
    }, [walletInfo, history]);

    const getBuyWidgetUrl = async () => {

        setIsSpinner(true)

        const params: BuyWidgetParams = {
            assetCode: asset.code,
            baseCurrencyCode: userInfo?.currency_code as string,
            provider: asset.providers['buy'][0],

        }


        try {

            const response = await dispatch(ebioroApi.endpoints.getBuyWidgetURL.initiate(params, { forceRefetch: true })).unwrap();
            await Browser.open({ url: response.url });
            setIsSpinner(false);


        } catch (error) {
            Sentry.captureException(error)
            setIsSpinner(false)
            presentErrorAlert(t('application.uncaught.ERROR'));
            return

        }
    }




    return (

        <IonPage ref={pageRef}>

            <IonHeader translucent={true}>

                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonButtons slot='start'>
                        <IonButton onClick={handleNavigation} color='primary'>
                            <IonIcon
                                slot="icon-only"
                                icon={goBack ? arrowBackOutline : closeOutline}
                            />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{t('receive.page.HEADER')}</IonTitle>

                </IonToolbar>
            </IonHeader>

            <IonContent scrollY={true} className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-slate-900 dark:to-slate-900">

                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{t('receive.page.HEADER')}</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <IonToast
                    isOpen={showToast}
                    onDidDismiss={() => setShowToast(false)}
                    cssClass="accountDetailsToast"
                    message={t('qrCodePageCopiedClipboardMessage') as string}
                    color="primary"

                    duration={600}
                    position="top"
                />

                <IonCard style={{ marginTop: "10%" }}>
                    <IonCardContent>
                        
                            <IonItem lines="none" button={true} disabled={true}>
                                <div slot="start" style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                    <IconContext.Provider value={{
                                        size: "32px",
                                        style: { color: 'var(--ion-color-primary)' }
                                    }}>
                                        <RiBankLine />
                                    </IconContext.Provider>
                                </div>
                                <IonLabel>{t('receive.page.BANK.TITLE')}</IonLabel>
                            </IonItem>
                    </IonCardContent>
                </IonCard>

                <IonCard
                    onClick={() => { getBuyWidgetUrl() }}
                >
                    <IonCardContent>
                            <IonItem lines="none" button={true}>
                                <div slot="start" style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                    <IconContext.Provider value={{
                                        size: "32px",
                                        style: { color: 'var(--ion-color-primary)' }
                                    }}>
                                        <RiBankCardLine />
                                    </IconContext.Provider>
                                </div>
                                <IonLabel>{t('receive.page.CREDIT_CARD.TITLE')}</IonLabel>
                            </IonItem>
                       
                    </IonCardContent>
                </IonCard>

                <IonCard
                    onClick={() => { presentRecieveStellarPayModal() }}
                >
                    <IonCardContent>

                            <IonItem lines="none" button={true}>
                                <div slot="start" style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                                    <IconContext.Provider value={{
                                        size: "32px",
                                        style: { color: 'var(--ion-color-primary)' }
                                    }}>
                                        <RiLink />
                                    </IconContext.Provider>
                                </div>
                                <IonLabel>{t('receive.page.REQUEST.TITLE')}</IonLabel>
                            </IonItem>
                    </IonCardContent>
                </IonCard>
            </IonContent>

        </IonPage>

    )
}

const ReceivePage: React.FC = () => (
    <Provider store={store}>
        <Page />
    </Provider>
);

export default ReceivePage;
// export default React.memo(ReceivePage);